export const SET_ALL_TASKCATEGORY = 'SET_ALL_TASKCATEGORY';

export const setAllTaskCategory = (taskCategory) => ({
  type: SET_ALL_TASKCATEGORY,
  payload: taskCategory,
});
